const getSeriesTooltipDot = (color) => {
  const newColor = color || "black";

  return `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${newColor}"></span>`;
};
export default getSeriesTooltipDot;
